<template>
    <div class="barBottom2">
        <h2 class="titlePage">
            Extras
        </h2>
        <div class="navImg2">
            <div class="icon-view">
                <div class="img-place">
                    <img src="@/assets/images/iconesextras/draps.png" alt="icone draps" />
                </div>
                <p>
                    <strong>DRAPS</strong>
                    <br />
                    Inclus
                </p>
            </div>
            <div class="icon-view">
                <div class="img-place">
                    <img src="@/assets/images/iconesextras/linge.png" alt="icone linge" />
                </div>
                <p>
                    <strong>LINGE DE TOILETTE</strong>
                </p>
                <p>6€/Pers.</p>

            </div>
            <div class="icon-view">
                <div class="img-place">
                    <img src="@/assets/images/iconesextras/menage.png" alt="icone menage" />
                </div>
                <p style="text-align: center;">
                    <strong>MENAGE<br>(si non réalisé)</strong>
                </p>
                <p>300€.</p>
                <!-- <p>Grand Gite (15 pers) : 300€.</p> -->
                <!-- <p>Petit Gite (6 pers) : 200€.</p>
                <p>L'Escale (02 pers) : 80€.</p> -->
            </div>
            <div class="icon-view">
                <div class="img-place">
                    <img src="@/assets/images/iconesextras/chauffage.png" alt="icone chauffage" />
                </div>
                <p>
                    <strong>CHAUFFAGE</strong>
                </p>
                <!-- <p>10€/jour (studio)</p> -->
                <!-- <p>25€/jour (Grand Gite)</p> -->
                <p>30€/jour</p>
            </div>
            <!-- <div class="icon-view">
                <div class="img-place">
                    <img src="@/assets/images/iconesextras/caution.png" alt="icone caution" />
                </div>
                <p>
                    <strong>CAUTION</strong>
                </p>
                <p>2000€</p>
            </div> -->
            <div class="icon-view">
                <div class="img-place">
                    <img src="@/assets/images/iconesextras/taxe.png" alt="icone taxe" />
                </div>
                <p>
                    <strong>TAXE DE SEJOUR</strong>
                </p>
                <p>1.70€/Pers/nuitée en sus</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Extra",
    data: function () {
        return {};
    },

    methods: {},
};
</script>
<style>
.barBottom2 {
    padding: 50px 20px;
    min-height: 375px;
}

.navImg2 {
    background: transparent;
    padding: 0.5rem 0;
    position: relative;
    bottom: 0;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: space-evenly;
    -ms-flex-pack: space-evenly;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: baseline;
    gap: 50px;
}

.navImg2 {
    margin-top: 100px !important;
    background-color: transparent !important;
    flex-wrap: wrap;
}

.icon-view {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.icon-view strong {
    font-size: 18px;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 800;
    color: #111;
}

.img-place {
    min-height: 100px;
    min-width: 100px;
    display: flex;
    justify-content: center;
}

.img-place>img {
    max-width: 100px;
}

@media all and (max-width: 768px) {}

@media (min-width:999px) and (max-width: 1439px) {}

@media (min-width:1440px) and (max-width: 1600px) {}
</style>